<template lang="pug">
div
  template(v-if='show === 2')
    .p-result__title モニタリング結果
    table.p-monitoring.u-margin__0
      tr
        td.u-padding__top--21 KURAMA ID
        td {{popup.kurama_id}}
      tr
        td 空間線量率(μSv/h)
        td {{popup.der}}
      tr
        td データ測定日時
        td {{popup.date}}
      tr
        td.u-padding__bottom--18 データ測定地点
        td {{popup.lat}} {{popup.lng}}
  template(v-else)
    .p-result__title モニタリング結果
    table.p-monitoring
      tr
        td メッシュコード
        td {{popup.mesh_code}}
      tr
        td メッシュ中央点
        td {{popup.lat}} {{popup.lng}}
      tr
        td 平均空間線量率(μSv/h)
        td {{popup.der}}
      tr
        td データ点数
        td {{popup.n_data}}
      tr
        td.u-padding__bottom--0 最新データ日時
        td.u-padding__bottom--0 {{popup.date}}
      tr
        td.u-padding__bottom--0 KURAMA
        td.p-select__ID
          el-select#p-sel(v-model='kuramaID', placeholder='選択してください' @change='changeId')
            el-option(v-for='(item, index) in popup.devices', :label='item', :value='item', :key='index')
    .p-result__dl.u-display__flex
      .p-dl__btn(@click='getSpectrumDataChild(popup.mesh_code)') スペクトル
      .p-dl__btn(@click='getTrendGraphChild(popup.mesh_code)') トレンドグラフ
</template>
<script>
export default {
  name: 'ElementPopup',
  data() {
    return {
      kuramaID: null,
    };
  },
  props: {
    popup: {
      type: Object,
      default: () => ({ count: 0 }),
    },
    show: {
      type: Object,
      default: () => ({ count: 0 }),
    },
  },
  methods: {
    getSpectrumDataChild(meshCode) {
      this.$emit('getSpectrumDataChild', meshCode);
    },
    getTrendGraphChild(meshCode) {
      this.$emit('getTrendGraphChild', meshCode);
    },
    changeId(id) {
      this.$emit('changeId', id);
      // eslint-disable-next-line vue/no-mutating-props
      this.popup.kuramaID = id;
    },
  },
  beforeUpdate() {
    this.kuramaID = this.popup.kuramaID;
  },
  mounted() {},
  created() {},
};
</script>
